var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-server-list"},[_c('ul',{staticClass:"fix"},_vm._l((_vm.list),function(v){return _c('li',{staticClass:"item fl"},[_c('icon',{attrs:{"iconClass":v.iconClass}}),_c('span',[_vm._v(_vm._s(v.lable))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }